<template>
  <div class="jessibuca-video-box" ref="videoRef">
    <div class="monitor">
      <!-- 头部 -->
      <div class="r-top">
        <div class="r-top-code">{{ langMap.codeLabel[lang] }}：{{ currentRobot.code }}</div>
        <div class="r-top-controls" v-if="false">
          <!-- 摄像头切换下拉菜单 -->
          <Dropdown trigger="click" @on-click="handleCameraChange" placement="bottom-start" transfer>
            <div class="camera-dropdown-btn" :title="langMap.switchCamera && langMap.switchCamera[lang] || '切换视角'">
              <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em">
                <path d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m0 64C311.466667 149.333333 149.333333 311.466667 149.333333 512s162.133333 362.666667 362.666667 362.666667 362.666667-162.133333 362.666667-362.666667S712.533333 149.333333 512 149.333333z m0 106.666667c141.376 0 256 114.624 256 256s-114.624 256-256 256-256-114.624-256-256 114.624-256 256-256z m0 64c-106.048 0-192 85.952-192 192s85.952 192 192 192 192-85.952 192-192-85.952-192-192-192z" fill="currentColor"></path>
              </svg>
              <span class="camera-label">{{ currentCameraLabel }}</span>
              <svg class="arrow-down" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="0.7em" height="0.7em">
                <path d="M512 714.666667c-8.533333 0-17.066667-2.133333-23.466667-8.533334l-341.333333-341.333333c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l320 317.866667 317.866667-320c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8l-341.333334 341.333333c-4.266667 8.533333-12.8 10.666667-21.333333 10.666667z" fill="currentColor"></path>
              </svg>
            </div>
            <DropdownMenu slot="list">
              <DropdownItem name="0" :selected="currentCameraType === '0'" v-if="isCameraAvailable('0')">
                {{ langMap.cameraLeftFront[lang] }}
              </DropdownItem>
              <DropdownItem name="1" :selected="currentCameraType === '1'" v-if="isCameraAvailable('1')">
                {{ langMap.cameraLeftRear[lang] }}
              </DropdownItem>
              <DropdownItem name="2" :selected="currentCameraType === '2'" v-if="isCameraAvailable('2')">
                {{ langMap.cameraRightFront[lang] }}
              </DropdownItem>
              <DropdownItem name="3" :selected="currentCameraType === '3'" v-if="isCameraAvailable('3')">
                {{ langMap.cameraRightSide[lang] }}
              </DropdownItem>
              <DropdownItem name="4" :selected="currentCameraType === '4'" v-if="isCameraAvailable('4')">
                {{ langMap.cameraLeftFrontRightRear[lang] }}
              </DropdownItem>
              <DropdownItem name="5" :selected="currentCameraType === '5'" v-if="isCameraAvailable('5')">
                {{ langMap.cameraLeftRearRightFront[lang] }}
              </DropdownItem>
              <DropdownItem name="6" :selected="currentCameraType === '6'" v-if="isCameraAvailable('6')">
                {{ langMap.cameraPanoramicFront[lang] }}
              </DropdownItem>
              <DropdownItem name="7" :selected="currentCameraType === '7'" v-if="isCameraAvailable('7')">
                {{ langMap.cameraPanoramicRear[lang] }}
              </DropdownItem>
              <DropdownItem name="8" :selected="currentCameraType === '8'" v-if="isCameraAvailable('8')">
                {{ langMap.cameraInfraredLeftRear && langMap.cameraInfraredLeftRear[lang] || '红外左后' }}
              </DropdownItem>
              <DropdownItem name="9" :selected="currentCameraType === '9'" v-if="isCameraAvailable('9')">
                {{ langMap.cameraInfraredRightFront && langMap.cameraInfraredRightFront[lang] || '红外右前' }}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="r-top-time">{{ time }}</div>
      </div>

      <!-- 机器人数据展示 -->
      <div class="r-show-data">
        <div class="left-monitoring">
          <!-- Jessibuca播放器容器 -->
          <div :id="`jessibuca_player_${playerId}`" class="video-container"></div>
          
          <!-- 音频控制按钮 -->
          <div class="audio-btn-box" @click="toggleMute" v-if="false">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1em" height="1em">
              <path d="M260.256 356.576l204.288-163.968a32 32 0 0 1 52.032 24.96v610.432a32 32 0 0 1-51.968 24.992l-209.92-167.552H96a32 32 0 0 1-32-32v-264.864a32 32 0 0 1 32-32h164.256zM670.784 720.128a32 32 0 0 1-44.832-45.664 214.08 214.08 0 0 0 64.32-153.312 213.92 213.92 0 0 0-55.776-144.448 32 32 0 1 1 47.36-43.04 277.92 277.92 0 0 1 72.416 187.488 278.08 278.08 0 0 1-83.488 198.976zM822.912 858.88a32 32 0 1 1-45.888-44.608A419.008 419.008 0 0 0 896 521.152c0-108.704-41.376-210.848-114.432-288.384a32 32 0 0 1 46.592-43.872c84.16 89.28 131.84 207.04 131.84 332.256 0 127.84-49.76 247.904-137.088 337.728z" fill="currentColor"></path>
            </svg>
            <p class="hidden-line" v-show="isMuted"></p>
          </div>

          <!-- 加载动画 -->
          <div class="buffer-loading-box" v-show="false">
            <p class="loading-content"><Spin fix></Spin></p>
            <div>{{ langMap.buffering[lang] }}</div>
          </div>

          <!-- 播放按钮 -->
          <div class="start-play" v-if="!isInitialized && !isLoading" @click="initPlayer">
            <div class="play-icon">▶</div>
            <div>{{ langMap.clickToPlay[lang]}}</div>
          </div>

          <!-- 错误提示 -->
          <div class="stream-error-message" v-if="streamError">
            {{ langMap.streamErrorTip[lang]}}
            <button class="refresh-btn" @click="handleRefresh">
              {{ langMap.refresh[lang] }}
            </button>
          </div>
        </div>
      </div>

      <!-- 不在线提示 -->
      <div class="state" v-if="offline">
        <div style="margin:20% auto;width: 80%;text-align: center">
          <p style="font-size: 30px;color: #FFFFFF">{{ langMap.robotIsOffline[lang] }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as timeUtil from "@/utils/dateTimeUtil.js";
import api from "@/api";
import langMap from '@/utils/language';
import { mapState } from 'vuex';

export default {
  name: "jessibuca-video",
  props: {
    robotId: {
      type: Number,
      default: ""
    },
    robotNum: {
      type: Number,
      default: 2
    },
    videoPlayUrlPrefix: {
      type: String,
      default: () => ""
    },
    // 从父组件接收相机信息
    cameraInfo: {
      type: Object,
      default: () => ({ currentType: '' })
    }
  },
  data() {
    return {
      langMap: langMap,
      id: "",
      timestamp: "",
      offline: false,
      time: "",
      currentRobot: {},
      
      // Jessibuca相关
      playerInfo: null,
      playerId: `stream_${Date.now()}_${Math.floor(Math.random() * 1000)}`,
      isInitialized: false,
      isLoading: false,
      streamError: false,
      isMuted: true,
      showAudioControl: false,

      // 摄像头切换相关
      currentCameraType: '', // 默认
      availableCameras: [], // 可用的相机列表
      cameraTypeMap: {
        '0': 'cameraLeftFront',
        '1': 'cameraLeftRear',
        '2': 'cameraRightFront',
        '3': 'cameraRightSide',
        '4': 'cameraLeftFrontRightRear',
        '5': 'cameraLeftRearRightFront',
        '6': 'cameraPanoramicFront',
        '7': 'cameraPanoramicRear',
        '8': 'cameraInfraredLeftRear',
        '9': 'cameraInfraredRightFront'
      },
      
      // 定时器
      timer: null,
      
      // 播放器配置
      playerConfig: {
        hasAudio: true,
        isLive: true,
        videoBuffer: 0.2,
        isResize: true,
        isFlv: true,
        debug: false,
        showBandwidth: true,
        operateBtns: {
          fullscreen: true,
          screenshot: false,
          play: true,
          audio: true,
        },
        vod: false,
        forceNoOffscreen: true,
        isNotMute: false,
      }
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    
    // 当前摄像头标签
    currentCameraLabel() {
      const labelMap = {
        '0': this.langMap.cameraLeftFront[this.lang],
        '1': this.langMap.cameraLeftRear[this.lang],
        '2': this.langMap.cameraRightFront[this.lang],
        '3': this.langMap.cameraRightSide[this.lang],
        '4': this.langMap.cameraLeftFrontRightRear[this.lang],
        '5': this.langMap.cameraLeftRearRightFront[this.lang],
        '6': this.langMap.cameraPanoramicFront[this.lang],
        '7': this.langMap.cameraPanoramicRear[this.lang],
        '8': this.langMap.cameraInfraredLeftRear && this.langMap.cameraInfraredLeftRear[this.lang] || '红外左后',
        '9': this.langMap.cameraInfraredRightFront && this.langMap.cameraInfraredRightFront[this.lang] || '红外右前'
      };
      return labelMap[this.currentCameraType] || this.langMap.selectView[this.lang];
    }
  },
  watch: {
    robotId: {
      handler(newId) {
        if (newId) {
          this.getInfo(newId);
        }
      },
      immediate: true
    },
    // 监听语言切换
    lang(newLang, oldLang) {
      if (newLang !== oldLang && this.isInitialized) {
        this.$nextTick(() => {
          this.translateJessibucaControls();
        });
      }
    },
    // 监听从父组件传来的相机类型变化
    'cameraInfo.currentType': {
      handler(newType) {
        if (newType !== undefined && newType !== '') {
          this.currentCameraType = newType;
          console.log('相机视角已更新:', newType);
        }
      },
      immediate: true
    }
  },
  methods: {
    formatTime(t) {
      if (!t) {
        return "";
      }
      return timeUtil.formatTime(t);
    },
    
    start() {
      timeUtil.startServerClock(this, (str) => {
        this.time = str;
      });
    },
    
    getInfo(id) {
      api.getData("robot-server/robot/get/" + id, this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.currentRobot = res.data;
          // 处理返回的摂像头默认值
          if (res.data && res.data.cameraSwitchType !== undefined) {
            this.currentCameraType = res.data.cameraSwitchType;
          }
          // 加载相机配置列表
          this.loadCameraConfig(res.data.code);
          
          if (!this.offline) {
            // 延迟初始化，确保DOM已渲染
            this.$nextTick(() => {
              setTimeout(() => {
                this.checkJessibucaAndInit();
              }, 100);
            });
          }
        }
      });
    },

    // 加载相机配置
    loadCameraConfig(robotCode) {
      if (!robotCode) return;
      
      api.getData(`robot-server/camera/switch/config/get?robotCode=${robotCode}`, this).then(res => {
        if (res.state === 1 && res.data && res.data.cameraTypes) {
          // 解析相机类型字符串，例如 "0,2,4"
          this.availableCameras = res.data.cameraTypes.split(',').map(type => type.trim());
          console.log('可用相机列表:', this.availableCameras);
          
          // 如果当前选中的相机不在可用列表中，清空选择让用户自己选
          if (this.currentCameraType && !this.availableCameras.includes(this.currentCameraType+'')) {
            this.currentCameraType = '';
            console.log('当前相机不在可用列表中，已清空选择');
          }
        } else {
          // 如果没有配置，使用默认列表
          this.availableCameras = ['0', '3', '4'];
        }
      }).catch(() => {
        // 加载失败时使用默认列表
        this.availableCameras = ['0', '3', '4'];
      });
    },

    // 检查相机是否可用
    isCameraAvailable(cameraType) {
      return this.availableCameras.includes(cameraType);
    },

    checkJessibucaAndInit() {
      // 检查 Jessibuca 是否可用
      if (typeof window.Jessibuca !== 'undefined') {
        console.log('Jessibuca found, ready to initialize');
        // 不自动播放，等待用户点击
      } else {
        console.warn('Jessibuca not found, retrying...');
        setTimeout(() => {
          this.checkJessibucaAndInit();
        }, 500);
      }
    },

    initPlayer() {
      if (this.isLoading || !this.currentRobot.code) return;
      
      this.destroyPlayer();
      this.streamError = false;
      this.isLoading = true;
      
      try {
        const playerId = `jessibuca_player_${this.playerId}`;
        const container = document.getElementById(playerId);
        
        if (!container) {
          console.error('找不到播放器容器元素:', playerId);
          this.isLoading = false;
          return;
        }

        const url = this.videoPlayUrlPrefix + "_left_" + this.currentRobot.code;
        console.log('初始化Jessibuca播放器, URL:', url);

        // 创建Jessibuca播放器实例
        this.playerInfo = new window.Jessibuca({
          container: container,
          decoder: './extra-js/jessibuca/decoder.js',
          loadingText: langMap.buffering[this.lang] || "加载中",
          ...this.playerConfig
        });

        this.setupPlayerEvents();
        this.startPlay(url);
        
      } catch (error) {
        console.error('播放器初始化失败:', error);
        this.streamError = true;
        this.isLoading = false;
      }
    },

    setupPlayerEvents() {
      const player = this.playerInfo;
      if (!player) return;

      // 播放事件
      player.on('play', () => {
        console.log('视频开始播放');
        this.streamError = false;
        this.isInitialized = true;
        this.isLoading = false;
        this.showAudioControl = true;
        // 替换播放器控件文案
        this.$nextTick(() => {
          this.translateJessibucaControls();
        });
      });

      // 暂停事件
      player.on('pause', () => {
        console.log('视频已暂停');
      });

      // 视频信息
      player.on('videoInfo', (info) => {
        console.log('视频信息:', info);
      });

      // 音频信息
      player.on('audioInfo', (info) => {
        console.log('音频信息:', info);
        this.showAudioControl = true;
      });

      // 全屏事件
      player.on('fullscreen', (flag) => {
        console.log('全屏状态:', flag);
        // 全屏状态改变时重新翻译控件文案
        this.$nextTick(() => {
          this.translateJessibucaControls();
        });
      });

      // 静音事件
      player.on('mute', (isMuted) => {
        console.log('静音状态:', isMuted);
        this.isMuted = isMuted;
        // 静音状态改变时重新翻译控件文案
        this.$nextTick(() => {
          this.translateJessibucaControls();
        });
      });

      // 加载超时
      player.on('timeout', () => {
        console.error('加载超时');
        this.streamError = true;
        this.isLoading = false;
      });

      // 加载事件
      player.on('load', () => {
        console.log('开始加载流');
      });

      // 播放异常
      player.on('error', (error) => {
        console.error('播放异常:', error);
        this.streamError = true;
        this.isLoading = false;
      });
    },

    startPlay(url) {
      const player = this.playerInfo;
      
      if (player && player.play) {
        console.log('开始播放HTTP-FLV流:', url);
        
        try {
          player.play(url);
        } catch (e) {
          console.error('播放失败:', e);
          this.streamError = true;
          this.isLoading = false;
        }
      } else {
        this.isLoading = false;
      }
    },

    destroyPlayer() {
      if (this.playerInfo) {
        try {
          this.playerInfo.destroy && this.playerInfo.destroy();
          this.playerInfo = null;
        } catch (error) {
          console.error('销毁播放器错误:', error);
        }
      }
      
      this.isInitialized = false;
      this.isLoading = false;
      this.showAudioControl = false;
    },

    toggleMute() {
      if (this.playerInfo && this.playerInfo.mute) {
        this.playerInfo.mute(!this.isMuted);
      }
    },

    handleRefresh() {
      this.streamError = false;
      this.destroyPlayer();
      setTimeout(() => {
        this.initPlayer();
      }, 100);
    },

    handleCameraChange(cameraType) {
      // 更新当前选中的摄像头类型
      this.currentCameraType = cameraType;

      const params = {
        code: this.currentRobot.code,
        data: {
          type: cameraType
        }
      };

      api
        .postData("notice-server/cmd/switch/camera", params, this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.$Notice.success({
              title: langMap.success[this.lang],
              desc: res.message
            });
          }
        });
    },

    // 翻译Jessibuca播放器控件文案
    translateJessibucaControls() {
      try {
        const container = document.getElementById(`jessibuca_player_${this.playerId}`);
        if (!container) return;

        // 查找控件元素并替换文案
        const controlsBottom = container.querySelector('.jessibuca-controls-bottom');
        if (!controlsBottom) return;

        // 替换播放按钮文案
        const playBtn = controlsBottom.querySelector('.jessibuca-play .icon-title');
        if (playBtn) {
          playBtn.textContent = langMap.jessibuca_play[this.lang];
        }

        // 替换暂停按钮文案
        const pauseBtn = controlsBottom.querySelector('.jessibuca-pause .icon-title');
        if (pauseBtn) {
          pauseBtn.textContent = langMap.jessibuca_pause[this.lang];
        }

        // 替换全屏按钮文案
        const fullscreenBtn = controlsBottom.querySelector('.jessibuca-fullscreen .icon-title');
        if (fullscreenBtn) {
          fullscreenBtn.textContent = langMap.jessibuca_fullscreen[this.lang];
        }

        // 替换退出全屏按钮文案
        const exitFullscreenBtn = controlsBottom.querySelector('.jessibuca-fullscreen-exit .icon-title');
        if (exitFullscreenBtn) {
          exitFullscreenBtn.textContent = langMap.jessibuca_exitFullscreen[this.lang];
        }

        // 替换静音/取消静音按钮的title属性
        const audioIcon = controlsBottom.querySelector('.jessibuca-icon-audio');
        if (audioIcon) {
          audioIcon.setAttribute('title', langMap.jessibuca_unmute[this.lang]);
        }

        const muteIcon = controlsBottom.querySelector('.jessibuca-icon-mute');
        if (muteIcon) {
          muteIcon.setAttribute('title', langMap.jessibuca_mute[this.lang]);
        }

        // 替换全屏按钮的title属性
        const fullscreenIcon = controlsBottom.querySelector('.jessibuca-fullscreen');
        if (fullscreenIcon) {
          fullscreenIcon.setAttribute('title', langMap.jessibuca_fullscreen[this.lang]);
        }

        // 替换暂停按钮的title属性
        const pauseIcon = controlsBottom.querySelector('.jessibuca-pause');
        if (pauseIcon) {
          pauseIcon.setAttribute('title', langMap.jessibuca_pause[this.lang]);
        }

        console.log('Jessibuca控件文案已翻译');
      } catch (error) {
        console.error('翻译Jessibuca控件文案失败:', error);
      }
    }
  },
  
  mounted() {
    this.start();
    
    // 网页重新激活后，刷新播放器
    window.onfocus = () => {
      if (this.playerInfo && this.isInitialized) {
        // Jessibuca 不需要手动调整时间，它会自动处理
        console.log('窗口重新获得焦点');
      }
    };
  },
  
  created() {
    this.id = this.robotId;
    this.timestamp = this.$route.query.timestamp;
  },
  
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.destroyPlayer();
  }
};
</script>

<style scoped lang="less">
.jessibuca-video-box {
  height: 100%;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  background-color: #000;
  position: relative;
}

.monitor {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

// 头部
.r-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 0;
  background-color: #000;
  color: #bab7b7;
  font-size: 20px;

  .r-top-code {
    padding-left: 10px;
    flex: 1;
  }

  .r-top-controls {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: center;
  }

  .r-top-time {
    flex-shrink: 0;
    padding-right: 35px;
    flex: 1;
    text-align: right;
  }
}

// 摄像头下拉按钮
.camera-dropdown-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(45, 140, 240, 0.1);
  border: 1px solid rgba(45, 140, 240, 0.3);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #2d8cf0;
  white-space: nowrap;

  svg {
    width: 18px;
    height: 18px;
    color: #2d8cf0;
    flex-shrink: 0;
  }
  
  .camera-label {
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
  }
  
  .arrow-down {
    width: 12px;
    height: 12px;
    margin-left: 2px;
  }

  &:hover {
    background: rgba(45, 140, 240, 0.2);
    border-color: rgba(45, 140, 240, 0.5);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(45, 140, 240, 0.2);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(45, 140, 240, 0.2);
  }
}

// 机器人数据展示
.r-show-data {
  display: flex;
  flex: 1;
  flex-direction: row;
  background-color: #001529;
  height: calc(100% - 50px);

  .left-monitoring {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    overflow: auto;
    justify-content: center;

    .video-container {
      width: 100%;
      height: 100%;
      background-color: #000;
    }
  }

  .audio-btn-box {
    position: absolute;
    bottom: 20px;
    left: 10px;
    z-index: 10;
    background-color: rgba(1, 0, 1, 0.6);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    color: white;
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      background-color: rgba(1, 0, 1, 0.3);
    }
    .hidden-line {
      position: absolute;
      margin: 0;
      padding: 0;
      width: 60%;
      left: 20%;
      height: 3px;
      top: 50%;
      transform: rotate(60deg);
      z-index: 3;
      background-color: white;
      border-radius: 6px;
    }
  }
}

// 播放按钮
.start-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  cursor: pointer;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5);
  padding: 20px;
  border-radius: 8px;

  .play-icon {
    font-size: 48px;
    margin-bottom: 10px;
  }

  div {
    font-size: 14px;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
}

// 错误提示
.stream-error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  border-radius: 8px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  width: 80%;
  max-width: 300px;

  .refresh-btn {
    background: #2d8cf0;
    border: none;
    color: #fff;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;

    &:hover {
      opacity: 0.8;
    }
  }
}

// 不在线提示
.state {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #000c17;
  width: 100%;
  height: 100%;
  z-index: 10000;
}

// 加载部分
.buffer-loading-box {
  position: absolute;
  width: 400px;
  left: 50%;
  margin-left: -200px;
  padding: 0 0 16px 0;
  top: 100px;
  z-index: 10;
  text-align: center;
  color: #2d8cf0;

  .ivu-spin-fix {
    background-color: transparent;
  }

  .loading-content {
    height: 40px;
    position: relative;
  }
}
</style>
